import ab from 'react-redux-hydra';

import { getMafiaAndCredentials } from 'store/ducks/readFromStore';
import {
  MAFIA_CREDIT_CARD_VERIFY_410058,
  MAFIA_NEXT_SHIPPING_OPTION_321483,
  MAFIA_SPLIT_SHIPMENTS_PLUGIN_377648,
  MARTY_441335
} from 'constants/weblabs';
import {
  HYDRA_CC_VERIFY,
  HYDRA_CHECKOUT_NEXT_DAY_SHIPPING,
  HYDRA_SPLIT_SHIPMENTS,
  HYDRA_VIP_ENROLLMENT_AT_CHECKOUT,
  HYDRA_WEAR_IT_WITH_UP
} from 'constants/hydraTests';
import { processHeadersMiddleware } from 'middleware/processHeadersMiddlewareFactory';
import { fetchNon200Middleware } from 'middleware/fetchErrorMiddleware';
import { setSessionCookies } from 'actions/session';
import { weblabTrigger } from 'apis/mafia';
import marketplace from 'cfg/marketplace.json';
const { cookieDomain } = marketplace;

const weblabExperimentToHydraAssignment = assignment => {
  switch (assignment) {
    case 'C':
      return 0;
    case 'T1':
      return 1;
    case 'T2':
      return 2;
    case 'T3':
      return 3;
    default:
      return 0;
  }
};

export const forceAssignAssignNextShipOption = () => dispatch => {
  dispatch(
    workRequestTriggerWeblabAssignment({
      weblab: MAFIA_NEXT_SHIPPING_OPTION_321483,
      hydraTest: HYDRA_CHECKOUT_NEXT_DAY_SHIPPING
    })
  );
};

export const forceAssignSplitShipments = () => dispatch => {
  dispatch(
    workRequestTriggerWeblabAssignment({
      weblab: MAFIA_SPLIT_SHIPMENTS_PLUGIN_377648,
      hydraTest: HYDRA_SPLIT_SHIPMENTS
    })
  );
};

export const forceAssignCreditCardVerify = () => dispatch => {
  dispatch(
    workRequestTriggerWeblabAssignment({
      weblab: MAFIA_CREDIT_CARD_VERIFY_410058,
      hydraTest: HYDRA_CC_VERIFY
    })
  );
};

export const forceAssignWearItWithUp = () => dispatch => {
  dispatch(
    workRequestTriggerWeblabAssignment({
      weblab: MARTY_441335,
      hydraTest: HYDRA_WEAR_IT_WITH_UP
    })
  );
};

export function workRequestTriggerWeblabAssignment({ hydraTest, weblab }, fetcher = weblabTrigger, forceAssignment = ab.actions.forceAssignment) {
  return (dispatch, getState) => {
    const { mafia, credentials } = getMafiaAndCredentials(getState());
    return fetcher(mafia, weblab, credentials)
      .then(processHeadersMiddleware(setSessionCookies(dispatch, getState)))
      .then(fetchNon200Middleware)
      .then(resp => {
        if (resp) {
          if (hydraTest) {
            const assignment = weblabExperimentToHydraAssignment(resp);
            dispatch(forceAssignment({ domain: cookieDomain }, hydraTest, assignment));
          }
          return resp;
        }
      });
  };
}

export function forceAssignVipEnrollmentAtCheckout(forceAssignment = ab.actions.forceAssignment) {
  return (dispatch, getState) => {
    const {
      shipOption: { isVipEnrollmentFeatureEnabled }
    } = getState();
    const assignment = isVipEnrollmentFeatureEnabled ? 1 : 0;
    dispatch(forceAssignment({ domain: cookieDomain }, HYDRA_VIP_ENROLLMENT_AT_CHECKOUT, assignment));
  };
}
